import React from 'react'

const SingleUserPage = () => {
  return (
    <div>Nothing here so far :D And probobly won't be...</div>
  )
}

export default SingleUserPage